<template>
  <div>
    <v-card>
      <v-card-title>
        Empresa: {{ empresa.nome }}
        <v-spacer />
        <tw-cadastro-empresa @update='consultaDados' :empresa="empresa">
          <template v-slot:activator="{ on }">
            <v-btn icon small v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </tw-cadastro-empresa>
      </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <div class="card-padding">
          <v-icon dense color="green darken-2"> mdi-clock-in </v-icon>
          Início do Atendimento às {{ empresa.inicioAtendimento | time }}.
        </div>
        <div class="card-padding">
          <v-icon dense color="green darken-2"> mdi-clock-out </v-icon>
          Término do Atendimento às {{ empresa.fimAtendimento | time}}.
        </div>
        <div class="card-padding">
          <v-icon dense color="green darken-2"> mdi-calendar-range </v-icon>
          Dias de Atendimento:
          <span v-for="dia in filteredArray" :key="dia.id" align="center">
            <v-chip class="ma-2" color="primary" outlined pill>
              {{ dia.semana }}
            </v-chip>
          </span>
        </div>
      </v-card-text>
    </v-card>
    <br />
    <v-card>
      <v-card-title>
        Usuário: {{ user.nome }}
        <v-spacer />
        <tw-cadastro-user @update='consultaDados' :user="user">
          <template v-slot:activator="{ on }">
            <v-btn icon small v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </tw-cadastro-user>
      </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <div class="card-padding">
          <v-icon dense color="green darken-2"> mdi-email </v-icon>
          {{ user.email }}
        </div>
        <div v-if="user.telefone" class="card-padding">
          <v-icon dense color="green darken-2"> mdi-phone </v-icon>
          {{ user.telefone }}
        </div>
        <div v-if="user.dataNascimento" class="card-padding">
          <v-icon dense color="green darken-2"> mdi-calendar-account </v-icon>
          {{ formatDate(user.dataNascimento) }}
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EmpresasService from '@/api/empresas-service';
import UserService from '@/api/user-service';
import CadastroUser from '@/modules/user/CadastroUser.vue';
import CadastroEmpresa from '@/modules/empresa/CadastroEmpresa.vue';
import diasSemana from '@/enums/day-of-week';
import _ from 'lodash';

function resetEmpresa() {
  return {
    id: null,
    nome: null,
    inicioAtendimento: null,
    fimAtendimento: null,
    diasAtendimento: [],
  };
}

function resetUser() {
  return {
    id: null,
    nome: null,
    email: null,
    telefone: null,
    dataNascimento: null,
  };
}

export default {
  data() {
    return {
      loadingForm: false,
      empresa: resetEmpresa(),
      user: resetUser(),
    };
  },
  mounted() {
    this.consultaDados();
  },
  methods: {
    consultaDados() {
      EmpresasService.getContext().then((empresaData) => {
        this.empresa = empresaData.data;
      });
      UserService.getContext().then((userData) => {
        this.user = userData.data;
      });
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
  },
  computed: {
    filteredArray() {
      const diasDaSemana = this.empresa.diasAtendimento.map((dia) => ({
        dia: diasSemana.keys[dia].value,
        semana: diasSemana.keys[dia].description,
      }));
      return _.orderBy(diasDaSemana, ['dia'], ['asc']);
    },
  },
  components: {
    twCadastroUser: CadastroUser,
    twCadastroEmpresa: CadastroEmpresa,
  },
};
</script>

<style>
.card-padding {
  padding: 5px;
}
</style>
